import { getLanguageFromLocale } from './getLanguageFromLocale';
import { languageMapper } from './localeHelper';

export const getLanguageLiteralFromLocale = (locale: string): string => languageMapper[getLanguageFromLocale(locale)];
